import React, { useContext, useState } from 'react';
import { GlobalSearchContext } from '../../context/GlobalSearchContext';
import { API_ROUTES, BROADCAST_NOTIFICATION_TYPE } from '../../utils/constant';
import { Alert, AlertTitle, Box, Button } from '@mui/material';
import HttpService from '../../hooks/Https-services';
import NotificationDialog from '../NotificaionDialog';

function ViewBroadcastNotifications() {
  const { broadcastNotifications, fetchBroadcastNotifications }: any =
    useContext(GlobalSearchContext);
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [currentAlert, setCurrentAlert] = useState<any>(null);

  const getSeverity = (alertType: number) => {
    switch (alertType) {
      case BROADCAST_NOTIFICATION_TYPE.success:
        return 'success';
      case BROADCAST_NOTIFICATION_TYPE.info:
        return 'info';
      case BROADCAST_NOTIFICATION_TYPE.warning:
        return 'warning';
      case BROADCAST_NOTIFICATION_TYPE.error:
        return 'error';
      default:
        return 'info';
    }
  };

  const markAsRead = async (id: any) => {
    try {
      setLoading(true);
      const data = { notificationId: id, markAsRead: true };
      await HttpService.patch(`${API_ROUTES.markAsRead}`, data);
      fetchBroadcastNotifications();
      setLoading(false);
      setOpenDialog(false);
    } catch (error) {
      console.error('Error marking notification as read:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDialogOpen = (alert: any) => {
    setCurrentAlert(alert);
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setCurrentAlert(null);
  };

  return (
    <Box>
      {broadcastNotifications &&
        broadcastNotifications.map((alert: any) => (
          <Alert
            key={alert.id}
            sx={{ borderRadius: 0, borderBottom: '1px solid #e0e0e0' }}
            severity={getSeverity(alert.broadcastAlertType)}
            action={
              <Button
                variant="outlined"
                color={getSeverity(alert.broadcastAlertType)}
                size="small"
                onClick={() => handleDialogOpen(alert)}
              >
                View Details
              </Button>
            }
          >
            <AlertTitle>{alert.message}</AlertTitle>
          </Alert>
        ))}

      {/* Dialog for displaying messageDescription */}

      <NotificationDialog
        loading={loading}
        openDialog={openDialog}
        handleDialogClose={handleDialogClose}
        currentAlert={currentAlert}
        markAsRead={markAsRead}
        isDispalyMarkAs={true}
      />
    </Box>
  );
}

export default ViewBroadcastNotifications;
